import { FormContextValues } from '@dreryk/react-common';

import { MedicalServicenNameForInvoicingFormPart, WithNameForInvoicing } from './nameForInvoicing.types';

export const nameForInvoicingVisitor = (bean: MedicalServicenNameForInvoicingFormPart) => <ACCEPT,>(visitor: {
   withNameForInvoicing?: (bean: WithNameForInvoicing) => ACCEPT;
   withoutNameForInvoicing?: () => ACCEPT;
}) => {
   if (bean.usingNameAsNameForInvoicing !== undefined) {
      return visitor.withNameForInvoicing?.(bean as WithNameForInvoicing);
   }

   return visitor.withoutNameForInvoicing?.();
};

export const nameForInvoicingPartVisible = (
   controller: FormContextValues<any>,
   invoiceCreateAvailable: boolean
): controller is FormContextValues<WithNameForInvoicing> => {
   return invoiceCreateAvailable;
};
